import Cookies from "js-cookie";

// Who is signed in. The login page stores the JWT in the `user_cookie`
// cookie and the role in `role_id` (see views/pages/authentication).

export const ROLES = {
  ORDER_ADMIN: 5,
  SUPER_ADMIN: 6,
  PAYMENT_ADMIN: 7,
  EDIT_ADMIN: 8,
};

export const ROLE_NAMES = {
  5: "Order admin",
  6: "Super admin",
  7: "Payment admin",
  8: "Edit admin",
};

// localStorage keys the pre-redesign pages wrote (tokens and saved filters).
const LEGACY_STORAGE_KEYS = ["api_token", "filter_options", "filter_Data"];

// Kept across sign-outs: layout preferences only (the sidebar rail and grid
// column layouts), which hold no user data. Everything else in localStorage
// (saved filters can hold search text such as mobile numbers) is cleared, as
// the old Logout did with localStorage.clear().
const KEEP_ON_LOGOUT = /^pa\.(shell|grid)\./;

export const getToken = () => Cookies.get("user_cookie") || "";

export const getUsername = () => Cookies.get("user_name") || "";

export const getRoleId = () => {
  const n = Number(Cookies.get("role_id"));
  return Number.isInteger(n) && n > 0 ? n : null;
};

// A role this admin panel serves (5, 6, 7, 8).
export const isKnownRole = (roleId = getRoleId()) => Object.prototype.hasOwnProperty.call(ROLE_NAMES, roleId);

// Signed in = a token and a role this app knows. A token with any other role
// (for example a stale cookie from the legacy CRM login) is not a session here.
export const isLoggedIn = () => Boolean(getToken()) && isKnownRole(getRoleId());

// roles: array of role ids; empty / undefined means any signed-in role.
export const hasRole = (roles, roleId = getRoleId()) => !roles || !roles.length || roles.includes(roleId);

export const roleName = (roleId = getRoleId()) => ROLE_NAMES[roleId] || "Admin";

export function logout() {
  Cookies.remove("user_cookie");
  Cookies.remove("role_id");
  Cookies.remove("user_name");
  try {
    LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) keys.push(localStorage.key(i));
    keys.filter((key) => key && !KEEP_ON_LOGOUT.test(key)).forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // storage unavailable: nothing to clear
  }
}
